/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListIndentDecrease = [
  ["path", { d: "M21 5H11" }],
  ["path", { d: "M21 12H11" }],
  ["path", { d: "M21 19H11" }],
  ["path", { d: "m7 8-4 4 4 4" }]
];

export { ListIndentDecrease as default };
//# sourceMappingURL=list-indent-decrease.js.map
